import Vue from 'vue';

import authService from '@topgeschenken/front-library-legacy/services/AuthService'
import GcBalanceChecker from './components/GcBalanceChecker'

class BalanceChecker {
  constructor(selector, credentials, config = {}) {
    this.selector = selector;
    this.credentials = credentials;

    this.config = {
      locale: 'nl_NL',
      translations: {
        nl_NL: {
          'Balance checker': 'Saldo checker',
          'Check balance': 'Check saldo',
          "Card number": 'Kaartnummer',
          'Verification code': 'Verificatie code',
          'The balance on the card is %currency% %balance%.': 'Het saldo op de kaart bedraagt %currency% %balance%.',
          'The card can be used until %date%': 'De kaart is te gebruiken t/m %date%.',
          'Required field': 'Verplicht veld',
          'Minimum is 6 characters': 'Bestaat uit min. 6 karakters',
          'Minimum is 10 characters': 'Bestaat uit min. 10 karakters',
          'Check other giftcard': 'Check nog een Giftcard',
          'Giftcard info': 'Giftcard gegevens',
          'Giftcard not found': 'Geen kaart gegevens gevonden.\nControleer de ingevulde gegevens.',
          'Confirm that you are not a robot': 'Bevestig dat je geen robot bent'
        }
      },
      ...config
    }

    Vue.prototype.$balanceChecker = {
      config: this.config,
      credentials: this.credentials
    };

    this.initTranslations();

    if (this.config.client_grant === 'client_credentials') {
      authService.loginByClientCredentials(credentials)
        .then(() => {
          this.createVueInstance();
        });

      return;
    }

    this.createVueInstance();
  }

  initTranslations() {
    const trans = this.config.translations[this.config.locale] || {};

    Vue.mixin({
      methods: {
        trans(key, replacements = {}) {
          let translation = trans[key] || key;

          const replaceKeys = Object.keys(replacements);
          if (replaceKeys.length !== 0) {
            for (const key of replaceKeys) {
              translation = translation.replace(key, replacements[key]);
            }
          }

          return translation;
        },
      }
    })
  }

  createVueInstance() {
    return new Vue({
      render(h) {
        return h(GcBalanceChecker)
      }
    }).$mount(this.selector);
  }
}

window.BalanceChecker = BalanceChecker;
